import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
import { SubjectsState } from '../../types';

type SubjectsAction = { type: string; payload?: SubjectsState | null };

const initialState: SubjectsState = {
  selectedSubject: null,
  allSubjectsList: null,
};

const subjectsReducer = (
  state: SubjectsState,
  action: SubjectsAction,
): SubjectsState => {
  switch (action.type) {
    case types.SET_SELECTED_SUBJECT:
      return {
        ...state,
        ...action.payload,
      };
    case types.SET_ALL_SUBJECTS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return initialState;
  }
};

type SubjectsContextType = [SubjectsState | null, Dispatch<SubjectsAction>];

export const SubjectsContext = createContext<SubjectsContextType>([
  initialState,
  () => initialState,
]);

const SubjectsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [subjectsInfo, dispatchSubjectsInfo] = useReducer(
    subjectsReducer,
    initialState,
  );

  return (
    <SubjectsContext.Provider value={[subjectsInfo, dispatchSubjectsInfo]}>
      {children}
    </SubjectsContext.Provider>
  );
};

export default SubjectsProvider;
